<script setup>
import { useUsersStore } from "@/stores"
import { storeToRefs } from 'pinia'

const usersStore = useUsersStore()
let loginDialogMode = null;
({ loginDialogMode } = storeToRefs(usersStore))

const openJoinDialog = () => {
  loginDialogMode.value = 'activate'
}

const openLoginDialog = () => {
  loginDialogMode.value = 'login'
}
</script>

<template>
  <div class="login-page">
    <div class="login-content max-content-width">
      <VCard class="pa-6">
        <VCol class="pa-4">
          <div class="login-description">
            <p class="mb-4">
              Network of Artists, Athletes, CEOs, Investors &amp; Restaurateurs who highly value where they dine
            </p>
            <p>
              Members use RM's app for premium bookings - hard-to-get reservations & elevated experiences at favorite/top places globally
            </p>
          </div>

          <div class="button-container">
            <VBtn
              color="primary"
              variant="flat"
              size="small"
              @click="openJoinDialog"
            >
              Request to Join
            </VBtn>
            <VBtn
              color="primary"
              variant="outlined"
              size="small"
              @click="openLoginDialog"
            >
              Log In
            </VBtn>
          </div>
        </VCol>
      </VCard>

      <!-- Menu Section -->
      <div class="profile-menu-section">
        <RouterLink
          to="/members"
          class="menu-item"
        >
          <div class="menu-item-text">
            How RM works & FAQs
          </div>
          <div class="menu-item-chevron">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m9 18 6-6-6-6" />
            </svg>
          </div>
        </RouterLink>
        <RouterLink
          to="/luxurypartners"
          class="menu-item"
        >
          <div class="menu-item-text">
            Luxury Partners
          </div>
          <div class="menu-item-chevron">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m9 18 6-6-6-6" />
            </svg>
          </div>
        </RouterLink>
        <RouterLink
          to="/preferred"
          class="menu-item"
        >
          <div class="menu-item-text">
            Preferred Restaurants
          </div>
          <div class="menu-item-chevron">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m9 18 6-6-6-6" />
            </svg>
          </div>
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.login-page {
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.login-content {
  width: 100%;
}

.login-description {
  font-size: 16px;
  line-height: 1.6;
  text-align: center;
  margin-bottom: 24px;
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
}

.profile-menu-section {
  align-self: stretch;
  width: 100%;
  margin-top: 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  background: rgb(var(--v-theme-surface));

  a.menu-item {
    display: flex;
    align-items: center;
    padding: 16px;
    transition: background-color 0.2s;
    background-color: transparent;
    text-decoration: none !important;
    color: rgb(51, 51, 51) !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
      text-decoration: none !important;
    }

    &:visited {
      color: rgb(51, 51, 51) !important;
    }
  }
}

.menu-item-text {
  font-size: 16px;
  color: rgb(51, 51, 51) !important;
  flex: 1 1 0%;
  text-decoration: none !important;
}

.menu-item-chevron {
  color: rgb(153, 153, 153);
  display: flex;
  align-items: center;
}
</style>

<route lang="yaml">
meta:
  layout: website
  redirectIfLoggedIn: true
</route>
